<template>
	<v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript">
				<p class="steps_count">2/8</p>
				1주일에 평균<br />
				<span class="steps_bolder_words">술은 며칠</span>이나<br />
				마시나요?
			</v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="center" align="center" class="pa-0 ma-0"></v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 px-7 py-16">
			<v-col cols="12" align-self="center" align="center" class="pa-0 slider-img">
				<span class="type-span">{{ slideIndex }}</span>
			</v-col>
			<v-col cols="12" align-self="center" align="center" class="px-auto mx-auto">
				<slide-picker
					ref="picker"
					:items="dayItems"
					:initial-index="0"
					:tab-index="1"
					@value="changeDay"
				/>
			</v-col>
		</v-row>
        <v-container class="ma-0 pa-0 pt-10 steps_container footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" align-self="end" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
import SlidePicker from '../../components/SlidePicker';

export default {
	data: () => ({
		enableButton: true,
		drnkHabit: 0,
		slideIndex: 0,
        dayItems: ['없음', '하루', '이틀', '사흘', '나흘', '닷새', '엿새', '이레'],
		slides: [
			{ title: "없음" },
			{ title: "하루" },
			{ title: "이틀" },
			{ title: "사흘" },
			{ title: "나흘" },
			{ title: "닷새" },
			{ title: "엿새" },
			{ title: "이레" }
		]
	}),

	methods: {
		...mapActions("survey", ["setCheckupTemp", "setStep"]),
        changeDay ({ index }) {
		    this.slideIndex = index
            this.drnkHabit = index
        },
		//이전
		previous() {
			this.setStep(5)
			this.$router.push("/checkup/step4");
		},
		//다음
		next() {
			const params = {
				step: 5,
				drnkHabit: this.drnkHabit
			};
			this.setCheckupTemp(params);

			//술을 마신적 없으면
			if (this.drnkHabit == 0) {
				this.setStep(6)
				this.$router.push("/checkup/step6");
			} else {
				this.setStep(5)
				this.$router.push("/checkup/step51");
			}
		},
		setSliderValue(index) {
			this.slideIndex = index;
			this.drnkHabit = index;
		},
		async restoreData() {
            await this.$nextTick()
			if (this.checkUp.drnkHabit) {
				this.drnkHabit = this.checkUp.drnkHabit;
				this.slideIndex = this.checkUp.drnkHabit;
				this.$refs.picker.setPosition(this.slideIndex)
			}
		}
	},
	mounted() {
		window.scrollTo(0, 0)
		this.setStep(5)
		this.restoreData()
	},
	computed: {
		...mapGetters("survey", {
			checkUp: "checkUp"
		})
	},
	components: {
        SlidePicker,
	}
};
</script>

<style scoped>
	.slider-img {
		height: 127px;
		/* width: 32vw; */
        background: url(~@/assets/images/ic-num-calendar.png) no-repeat;
        background-size: contain;
		background-position: center center;
	}

	.type-span {
		line-height: 5.5;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: "NanumSquare", sans-serif;
        font-weight: 700;
		font-size: 28px;
		letter-spacing: -0.36px;
		text-align: center;
		color: #ffffff;
	}

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
</style>
